import { capitalize } from 'lodash';
import React, { useContext } from 'react';
import { BucketFormikInput as FormikInput } from 'Src/types/forms';
import { RadioGroup } from 'Components/frameworks/formik/RadioGroup';
import { useAppContext } from 'Context/ReactAppContext';
import { t } from 'Src/i18n';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { BookingEngineContext } from 'Views/booking/BookingEngineContext';
import type { ValidatorsType } from 'Components/widgets/contact-info/ContactInfoUtils';
import 'Components/widgets/contact-info/ContactInfoUtils';
import type { CivilitiesType } from './PersonInfoUtils';
import './PersonInfoUtils';
type Props = {
  adultCivilities: CivilitiesType;
  attendeeIdentifier: string;
  childCivilities: CivilitiesType;
  isChild: boolean;
  validators: ValidatorsType;
  hideErrorMessage?: boolean;
  isDisabled?: boolean;
};
export const CivilityInputBlock = ({
  attendeeIdentifier,
  childCivilities,
  adultCivilities,
  isChild,
  validators,
  hideErrorMessage,
  isDisabled,
}: Props) => {
  const appContext = useAppContext();
  const beEngineContext = useContext(BookingEngineContext);
  const displayParticipantsSelectInput =
    isFeatureFlipped(appContext)('booking.displayCivilityDropdown') &&
    beEngineContext?.currentStep?.name === 'participants';
  return displayParticipantsSelectInput ? (
    <FormikInput
      dataTestId="participantsSelectInput"
      className="p-10 sm:w-2/3"
      hideErrorMessage={hideErrorMessage}
      isRequired
      label={capitalize(t('booking.participants.labels.civility'))}
      type="select"
      name={`${attendeeIdentifier}.civility`}
      placeholder={capitalize(t('booking.participants.labels.civility'))}
      options={(isChild ? childCivilities : adultCivilities).map((option) => ({
        ...option,
        name: option.label,
      }))}
      validate={isChild ? validators.childCivilities : validators.adultCivilities}
      isDisabled={isDisabled}
    />
  ) : (
    <RadioGroup
      className="p-10 sm:w-2/3"
      isRequired
      name={`${attendeeIdentifier}.civility`}
      options={isChild ? childCivilities : adultCivilities}
      validate={isChild ? validators.childCivilities : validators.adultCivilities}
      hideErrorMessage={hideErrorMessage}
      isDisabled={isDisabled}
    />
  );
};
